<template>
  <div class="login-container">
    <div class="login-box">
      <div class="logo">
        <div class="envelope">📧</div>
        Email Hint
      </div>
      <form @submit.prevent="login">
        <p>To get a password hint please enter your email address below</p>
        <input
          type="email"
          v-model="email"
          placeholder="Email"
          required
          autocomplete="off"
        />
        <button type="submit" @click="GameSetup()">Get Hint</button>
        <template v-if="hint == ''"> </template>
        <template v-else>
          <div class="message">
            <p>{{ hint }}</p>
          </div>
        </template>
        <div class="footer">
          <a href="#" @click="goBack()">Back To Login</a>
        </div>
      </form>
    </div>
  </div>
</template>


<!-- <template>
  <div class="center">


    <div class="container">
      <template v-if="error != ''">
        <div class="row">
          <p>{{ error }}</p>
        </div>
      </template>
      <a @click="goBack()"> back to login</a>
      <div class="row">
        <input class="input" placeholder="email" v-model="email" />
      </div>
      <div class="row">
        <button class="button" type="submit" @click="GameSetup()">Show Hint</button>
      </div>
      <div class="row" v-if="hint != ''">
        <p>{{ this.hint }}</p>
      </div>
    </div>

  </div>
</template> -->

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(to right, #004d99, #66b2ff);
}

.login-box {
  width: 300px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #004d99;
  margin-bottom: 20px;
}

.envelope {
  font-size: 32px;
  position: relative;
}

.spark {
  position: absolute;
  top: 5px;
  right: -5px;
  font-size: 18px;
}

input {
  width: 90%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #004d99;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.message {
  color: red;
}

button:hover {
  background-color: #003366;
}

.footer {
  margin-top: 15px;
  font-size: 14px;
}

a {
  color: #004d99;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
<script>
import axios from "axios";
export default {
  name: "hint",
  props: {
    emailadd: String,
  },
  data() {
    return {
      teamName: "",
      nameError: false,
      email: "",
      error: "",
      hint: "",
    };
  },
  async mounted() {
    this.email = this.emailadd;
  },
  methods: {
    back() {
      this.hint = "";
    },
    async goBack() {
      this.$emit("gotoLogin", this.emailadd);
    },
    async GameSetup() {
      this.hint = "";
      if (this.email == "mmccarpyseaside@gmail.com") {
        this.hint = "Favourite food 123!";
      } else {
        this.hint = "No Hint Available";
      }
    },
  },
};
</script>


